import { func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import api from '../../../REST/api';
import withApiRequest from '../../../REST/with-api-request';
import HELP_TEXTS from '../../help-texts';

function ExportWithSegmentations({ onRequest, contactListId, ...rest }) {
  return (
    <Button onClick={() => onRequest(contactListId)} {...rest}>
      Export with segmentations{' '}
      {getInfoTooltip(
        HELP_TEXTS,
        'exportContactsWithSegmentations',
        'actionButtons',
        'top',
      )}
    </Button>
  );
}

ExportWithSegmentations.propTypes = {
  onRequest: func.isRequired,
  contactListId: number.isRequired,
};

export default withApiRequest({
  query: api.exportContactsWithSegmentations,
  error: 'flash',
  successMessage: 'Email with contacts and segmentations is being prepared',
})(ExportWithSegmentations);
